//
//
//
//

import GoogleMapStreetviewWrapper from "@Shared/components/general/google-map-streetview-wrapper.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "GoogleMapStreetView",
  components: {
    GoogleMapStreetviewWrapper
  },
  data() {
    return {
      location: this.$route.query.address
    };
  }
});